// extracted by mini-css-extract-plugin
module.exports = {"heading":"Recommendations_heading__VpMND","description":"Recommendations_description__tgMxX","grid":"Recommendations_grid__LrED2"};